import React from "react";
import Tools from './utils/Tools';
import $ from 'jquery';
var strings = Tools.getStrings();

export default class WPHeader extends React.Component {

    constructor(props) {
        super(props);

        var extras = window.WebApp.getCart().getData().extras;
        this.state = {
            changedLocal:false,
            menus:{prices:[],total:0},
            extrasInfo:{info:[],total:0,prices:[]},
            extras:extras,
            menuVisibility:'hidden',
            cartVisibility:'hidden',
            total:0,
            user:null,
            profileMenuVisible:false,
            isLogged: false,
            tax:"0",
            device:'desktop',
            url:"",
            promocode:"",
            totalWithDiscount:0,
            totalDiscount:0,
            validatingPromoTxt:"",
            codeValidated:false,
            lang:Tools.getLang(),
            direction:"up",
            lastScrollTop:0,
            numItems:window.WebApp.getCart().cartLength(),
            priceRulesDiscount: 0,
            collections: [],
            mobilecollections: false,
            showlang: false,
            showprofile: false
        }

        this.checkDevice = this.checkDevice.bind(this);
        this.handleCartChange = this.handleCartChange.bind(this);
        this.calcPrice = this.calcPrice.bind(this);
    }

    componentDidMount() {
        var component = this;

        $(window).resize(function() {
            component.checkDevice();
        });
        this.checkDevice();

        this.handleCartChange();
        window.WebApp.getFlux().setNotifyCart(this.handleCartChange);

        window.WebApp.getAccount().authCheck((result) => {
            var tax = "0";
            if(result.zipcode !== null && result.zipcode !== undefined) {
                tax = result.zipcode.tarifa;
            }
            this.setState({
                isLogged:!result.expired,
                tax:tax
            });
        });

        const _this = this;
        $(document).mouseup(function(e) {
            var container = $(".profile-drop");
            if (!container.is(e.target) && container.has(e.target).length === 0) 
            {
                _this.setState({
                    showprofile: false
                });
            }
            var container2 = $(".lang-drop");
            if (!container2.is(e.target) && container2.has(e.target).length === 0) 
            {
                _this.setState({
                    showlang: false
                });
            }
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if(!prevProps.openCart && this.props.openCart && prevState.cartVisibility === "hidden") {
            this.handleCart();
        }
    }
    

    componentWillUnmount() {
        window.WebApp.getFlux().unsetNotifyCart(this.handleCartChange);
    }

    handleCartChange() {
        let donotcalc = this.props.donotcalc === true ? true : false;
        if(!this.state.changedLocal && !donotcalc) {
            this.setState({
                extras: window.WebApp.getCart().getData().extras,
                numItems: window.WebApp.getCart().cartLength()
            })
            this.calcPrice();
        }
    }

    checkDevice() {
        var component = this;
        if($(window).width() < 825) {
            if(component.state.device === 'desktop') {
                component.setState({
                    device:'mobile'
                })
            }
        }else {
            if(component.state.device === 'mobile') {
                component.setState({
                    device:'desktop'
                })
            }
        }
    }

    calcPrice() {
        window.WebApp.getNetwork().getLoading().doNotLoad(-1);
        var data = {order:window.WebApp.getCart().getData(), promocode:this.state.promocode};
        window.WebApp.getCheckout().calculatePriceWithPromo(data, (result) => {
            var totalWithDiscount = 0;
            var totalDiscount = 0;
            if(result.metapromo !== null) {
                var metapromo = result.metapromo;
                var total = result.menusInfo.total + result.extrasInfo.total;
                if(metapromo.discount.type === 'fix') {
                    totalDiscount = metapromo.discount.price;
                    totalWithDiscount = total - totalDiscount;
                }else {
                    totalDiscount = total * metapromo.discount.price;
                    totalWithDiscount = total - totalDiscount;
                }
                totalWithDiscount = (totalWithDiscount < 0 ? 0 : totalWithDiscount);
            }
            var menus = {prices:[],total:0};
            if(result.menusInfo !== undefined && result.menusInfo.prices !== undefined) {
                menus = result.menusInfo;
            }
            if(result.tax == null) {
                result.tax = 0;
            }
            let tax = result.tax;
            this.setState({
                menus:menus,
                extrasInfo:result.extrasInfo,
                url:result.frontoffice_url,
                priceRulesDiscount: result.priceRulesDiscount,
                totalWithDiscount,
                totalDiscount,
                tax
            });
        });
    }

    handleMenu() {
        if(this.state.menuVisibility === "hidden") {
            $('.menu').show();
            $('.menu').animate({
                left:"0px"
            },500);
            this.setState({
                menuVisibility: "visible"
            });
        }
        else {
            $('.menu').animate({
                left:"-100%"
            },500, function(){
                $('.menu').hide();
            });
            this.setState({
                menuVisibility: "hidden"
            });
        }
    }

    handleCart() {
        if(this.state.cartVisibility === "hidden") {
            this.calcPrice();
            $('.cart').show();
            $('.cart').animate({
                right:"0px"
            },500);
            this.setState({
                cartVisibility: "visible"
            });
        }
        else {
            $('.cart').animate({
                right:"-400px"
            },500, function(){
                $('.cart').hide();
            });
            this.setState({
                cartVisibility: "hidden"
            });
        }
    }

    profilePage() {
        if(this.state.isLogged) {
            this.setState({
                showprofile: !this.state.showprofile,
                showlang: false
            })
        }else {
            window.location.href = "/login";
        }
    }

    checkout() {
        if(this.state.isLogged) {
            window.location.href = "/checkout";
        }else {
            localStorage.setItem('from', 'checkout');
            window.location.href = "/login";
        }
    }

    removeMenu(index) {
        window.WebApp.getCart().removeMenu(index, function() {
            this.setState({
                numItems:window.WebApp.getCart().cartLength()
            });
        }.bind(this));
    }

    removeExtra(index) {
        window.WebApp.getCart().removeExtra(index, function() {
            this.setState({
                numItems:window.WebApp.getCart().cartLength()
            });
        }.bind(this));
    }

    lessProduct(type, index) {
        window.WebApp.getCart().removeOne(type, index, (() => {}));
    }

    moreProduct(type, index) {
        window.WebApp.getCart().addOne(type, index, (() => {}));
    }

    changeLang(lang) {
        if(lang !== Tools.getLang()) {
            Tools.setLang(lang);
            if(lang === 'pt') {
                lang = "";
            }
            switch (window.location.pathname) {
                case '/en/loja/':
                    window.location.href="/loja/";
                    break;
                case '/loja/':
                    window.location.href="/en/loja/";
                    break;
                case '/en/areapessoal/':
                    window.location.href="/areapessoal/";
                    break;
                case '/areapessoal/':
                    window.location.href="/en/areapessoal/";
                    break;
                case '/en/checkout/':
                    window.location.href="/checkout/";
                    break;
                case '/checkout/':
                    window.location.href="/en/checkout/";
                    break;
                default:
                    
                    window.location.href="/"+lang;
                    break;
            }
        }
    }

    logout() {
        window.WebApp.getAccount().logout((result) => {
            window.location.href="/";
        });
    }

    render() {
        return (
            <div className="header">
                <div className={"main-header" + (window.tipo === "btb" ? " btb" : "")}>
                    <div className="main-container flex between align-center">
                        <div style={{width:"95px"}}>
                            <img alt="menu" onClick={() => this.handleMenu()} className="menu-icon" src={window.tipo === "btb" ? window.menubtb : window.menu}/>
                        </div>
                        <div className="flex1 center-text">
                            <a href="/"><img alt="logo" className="logo" src={window.tipo === "btb" ? window.logobtb : window.logo}/></a>
                        </div>
                        <div className="flex end">
                            <div className={"profile" + (this.state.showprofile ? " dropactive" : "")} onClick={() => this.profilePage()}>
                                <div>
                                    <img alt="perfil" className="right-icon" src={window.tipo === "btb" && !this.state.showprofile ? window.perfilbtb : window.perfil}/>
                                </div>
                                {this.state.showprofile &&
                                    <div className="drop profile-drop">
                                        <p>{strings.yourprofile}</p>
                                        <hr/>
                                        <p><a className="green" href="/areapessoal#dados">{strings.mydata}</a></p>
                                        <p style={{paddingTop:"0px"}}><a className="green" href="/areapessoal#encomenda">{strings.activeorders}</a></p>
                                        <p style={{paddingTop:"0px"}}><a className="green" href="/areapessoal#historico">{strings.orderhistory}</a></p>
                                        <p style={{paddingTop:"0px"}}><a className="green" href="/loja">{strings.order}</a></p>
                                        <hr/>
                                        <p className="pointer" onClick={() => this.logout()}>Log out</p>
                                    </div>
                                }
                            </div>
                            <div className="cart-wrapper">
                                <img alt="carrinho" style={{marginLeft:"20px"}} className="right-icon" onClick={() => this.handleCart()} src={window.tipo === "btb" ? window.carrinhobtb : window.carrinho}/>
                                {(this.state.menus.prices.length > 0 || this.state.extras.length > 0) &&
                                    <div className="has-items pointer">{this.state.numItems}</div>
                                }
                            </div>
                        </div>
                    </div>
                </div>

                <div className="menu">
                    <div className="main-container" style={{textAlign: "left"}}>
                        <img alt="fechar" src={window.fecharmenu} className="close-menu" onClick={() => this.handleMenu()}/>
                    </div>
                    <div className="center-text">
                        <img alt="logo" src={window.logo}/>
                        <div>
                            <h3><a href="/">Home</a></h3>
                            <h3><a href="/loja">Loja</a></h3>
                            <h3><a href="/sobre-nos">Sobre nós</a></h3>
                            <h3><a href="/catering">Catering</a></h3>
                            <h3><a href="/contactos">Contactos</a></h3>
                            <h3><a href="/trabalhe-connosco">Trabalhe connosco</a></h3>
                        </div>
                    </div>
                </div>

                <div className="cart">
                    <img alt="fechar" src={window.fechar} className="close-cart" onClick={() => this.handleCart()}/>
                    <h2 className="green">{strings.cart1}</h2>
                    {window.WebApp.getCart().isCartEmpty() &&
                        <div className="center-text">
                            <p style={{marginTop:"15px",marginBottom:"30px", textAlign:"center"}}>
                                {strings.cartempty}
                            </p>
                            <a href="/loja">
                                <button>{strings.add}</button>
                            </a>
                        </div>
                    }
                    {!window.WebApp.getCart().isCartEmpty() &&
                        <div>
                            <div className="cart-items">
                                {this.state.menus.prices.map((product, index) => {
                                    return (
                                        <div key={index}>
                                            <div className="cart-line">
                                                <div className="flex between">
                                                    <p><span className="green f700">{product.quantity}x</span> <span className="f600">{product.name}</span></p>
                                                    <p>{(product.quantity*product.price).toFixed(2)}</p>
                                                </div>
                                                {product.composition !== undefined &&
                                                    <p className="composition">
                                                        {product.composition.products.map((comp, compIndex) => {
                                                            return (
                                                                <span key={compIndex}>{comp.name + (compIndex < product.composition.products.length - 1 ? ", " : "")}</span>
                                                            )
                                                        })}
                                                    </p>
                                                }
                                                <div className="flex between" style={{marginTop:"15px"}}>
                                                    <div className="flex between quantities">
                                                        <div className="quantity-btn minus"
                                                            onClick={() => this.lessProduct("menu",index)}>
                                                            <img alt="menos" src={window.menos}/>
                                                        </div>
                                                        <div className="quantity-btn plus"
                                                            onClick={() => this.moreProduct("menu",index)}>
                                                            <img alt="mais" src={window.mais}/>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                                {this.state.extras.map((product, index) => {
                                    if(product.quantity > 0) {
                                        let price = (parseFloat(product.price)*product.quantity).toFixed(2);
                                        if(this.state.extrasInfo.prices[index] !== undefined){
                                            price = (parseFloat(this.state.extrasInfo.prices[index].price)*product.quantity).toFixed(2);
                                        }
                                        return (
                                            <div key={index}>
                                                <div className="cart-line">
                                                    <div className="flex between">
                                                        <p><span className="green f700">{product.quantity}x</span> <span className="f600">{product.name}</span></p>
                                                        <p>€{price}</p>
                                                    </div>
                                                    {product.composition !== undefined &&
                                                        <p className="composition">
                                                            {product.composition.products.map((comp, compIndex) => {
                                                                return (
                                                                    <span key={compIndex}>{comp.name + (compIndex < product.composition.products.length - 1 ? ", " : "")}</span>
                                                                )
                                                            })}
                                                        </p>
                                                    }
                                                    <div className="flex between" style={{marginTop:"15px"}}>
                                                        <div className="flex between quantities">
                                                            <div className="quantity-btn minus"
                                                                onClick={() => this.lessProduct("extra",index)}>
                                                                <img alt="menos" src={window.menos}/>
                                                            </div>
                                                            <div className="quantity-btn plus"
                                                                onClick={() => this.moreProduct("extra",index)}>
                                                                <img alt="mais" src={window.mais}/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    }
                                    return null;
                                })}
                            </div>
                            <div>
                                {!window.WebApp.getCart().isCartEmpty() &&
                                    <React.Fragment>
                                        <hr/>
                                        {true === false && !window.WebApp.getCart().isCartEmpty() && this.state.tax !== null && this.state.tax !== undefined &&
                                            <div className="flex between">
                                                <p className="green f700 flex1">{strings.tax}</p>
                                                <p className="green f700">{parseFloat(this.state.tax).toFixed(2)}€</p>
                                            </div>
                                        }
                                        <div className="flex between">
                                            <p className="green f700 flex1 uppercase">{strings.total}</p>
                                            {(this.state.totalWithDiscount !== 0 || (this.state.totalWithDiscount === 0 && this.state.totalDiscount !== 0)) &&
                                                <p className="green f700">
                                                    {(this.state.totalWithDiscount).toFixed(2)}€
                                                </p>
                                            }
                                            {this.state.totalWithDiscount === 0 && this.state.totalDiscount === 0 &&
                                                <p className="green f700">
                                                    {(this.state.menus.total + this.state.extrasInfo.total).toFixed(2)}€
                                                </p>
                                            }
                                        </div>
                                        <button onClick={() => this.checkout()} style={{width: "100%", marginTop:"30px"}}>{strings.finalize2}</button>
                                    </React.Fragment>
                                }
                            </div>
                        </div>
                    }
                </div>
                <div className="body-overlay"></div>
                <div className="loadingContainerv2">
                    <div style={{position:"relative", height:"100vh"}}>
                        <div id="logo_loading">
                            <img alt="logo" src={window.loadinglogo}/>
                            <p>LOADING<span>.</span><span>.</span><span>.</span></p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
